/**
 * Amasty Multiple Wishlist compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import BrowserDatabase from 'Util/BrowserDatabase';
import { history } from 'Util/History';
import { fetchMutation } from 'Util/Request/Mutation';

import AmDeleteWishlistMutationQuery from '../../query/AmDeleteWishlistMutation.query';
import { ItemType, WishlistPopupType } from '../../type/MultipleWishlist.type';
import { getIsWishlistPopup } from '../../util/MultipleWishlist';
import { WISHLIST_ADD, WISHLIST_OPERATION_MOVE } from '../AmastyWishlistItem/AmastyWishlistItem.config';
import { AMASTY_OPERATION } from '../MultipleWishlist/MultipleWishlist.config';
import MultipleWishlistItem from './MultipleWishlistItem.component';

/** @namespace Scandiweb/AmastyMultipleWishlist/Component/MultipleWishlistItem/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    wishlistPopup: state.PopupReducer?.popupPayload,
    isMobile: state.ConfigReducer.device.isMobile,
});

/** @namespace Scandiweb/AmastyMultipleWishlist/Component/MultipleWishlistItem/Container/mapDispatchToProps */
export const mapDispatchToProps = (_dispatch) => ({});

/** @namespace Scandiweb/AmastyMultipleWishlist/Component/MultipleWishlistItem/Container */
export class MultipleWishlistItemContainer extends PureComponent {
    static propTypes = {
        item: ItemType.isRequired,
        handleClick: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        wishlistPopup: WishlistPopupType,
        setDeletedList: PropTypes.func,
        isMobile: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        wishlistPopup: null,
        setDeletedList: () => {},
    };

    containerFunctions = {
        handleClick: this.handleClick.bind(this),
        handleDelete: this.handleDelete.bind(this),
        handleButtonMoreClick: this.handleButtonMoreClick.bind(this),
    };

    __construct(props) {
        super.__construct(props);

        this.state = {
            isClicked: false,
            isExpanded: false,
        };
    }

    handleClick() {
        const { item: { wishlistId }, handleClick, item } = this.props;

        if (getIsWishlistPopup()) {
            this.setState({ isClicked: true });
            handleClick(item);

            return;
        }

        const link = `wishlists/wishlistId/${wishlistId}`;

        this.setState({ isClicked: true });

        handleClick(item);
        history.push(link);
    }

    handleButtonMoreClick() {
        const { isExpanded } = this.state;

        this.setState({ isExpanded: !isExpanded });
    }

    async handleDelete() {
        const {
            item: {
                wishlistId,
                name,
            },
            showNotification,
            setDeletedList,
        } = this.props;

        this.setState({ isExpanded: false });

        const {
            deleteWishList: { message },
        } = await fetchMutation(AmDeleteWishlistMutationQuery.getQuery(wishlistId));

        const messageToShow = message === 'This list was deleted' ? __('This list was deleted') : message;

        showNotification(messageToShow);

        setDeletedList(name);

        BrowserDatabase.setItem(WISHLIST_OPERATION_MOVE, AMASTY_OPERATION);
    }

    containerProps() {
        const { item, wishlistPopup } = this.props;
        const { isClicked, isExpanded } = this.state;

        const isProductPage = Object.keys(wishlistPopup).length
            ? Object.keys(wishlistPopup)[0] === WISHLIST_ADD
            : false;

        return {
            item,
            isClicked,
            isExpanded,
            isProductPage,
        };
    }

    render() {
        return (
            <MultipleWishlistItem
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleWishlistItemContainer);
